// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {586: "recorder",621: "profiler",}[chunkId] + "-internal-fabfe0c9-99c1-494e-9125-016eed066720-" + {586: "35cb663321e57e3f",621: "763a4d9dfc8c1074",}[chunkId] + ".js"
}